// Perfect Sound for Every Moment
// Leisure
let Leisure_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ]
}

// Travel
let Travel_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ]
}

// Fitness
let Fitness_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Fit & Comfort',
      content: 'Look for ergonomic designs that provide a snug fit, such as ear hooks or in-ear buds, to ensure they stay in place during intense movement.',
    },
    {
      id: 2,
      product: '',
      title: 'Fit Stability',
      content: 'The earphones need to stay firmly in place, especially during high-intensity activities like running, preventing you from constantly adjusting them.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Sweat & Water Resistance',
      content: 'Choose headphones with at least an IPX4 rating to ensure they withstand sweat and moisture.',
    },
    {
      id: 2,
      product: '',
      title: 'Durability',
      content: 'Choose earphones with a rugged build that is resistant to drops and scratches, ensuring long-lasting performance, especially in outdoor or high-impact environments.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Battery Life',
      content: "Opt for models with long battery life if you're working out for extended periods, ideally 8+ hours.",
    },
    {
      id: 2,
      product: '',
      title: 'Charging Efficiency',
      content: 'Some earphones offer quick charging, which can provide several hours of use in just a few minutes—beneficial for frequent users.',
    },
    {
      id: 3,
      product: '',
      title: 'Control Features',
      content: 'Easy-to-use on-device controls or voice assistants can make it simple to adjust music or take calls without interrupting your workout.',
    },
    {
      id: 4,
      product: '',
      title: 'Smart Features',
      content: 'Features like voice assistants or adaptive audio settings minimize manual adjustments, allowing users to focus more on their workout.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Sound Quality',
      content: 'Clear sound with strong bass can enhance your workout experience, delivering a more powerful and intensive sound.',
    },
    {
      id: 2,
      product: '',
      title: 'Connectivity',
      content: 'Wireless headphones with Bluetooth 5.3 or higher ensure stable connectivity, especially in crowded gym spaces.',
    },
    {
      id: 3,
      product: '',
      title: 'Device Compatibility',
      content: 'Ensure the earphones are compatible with multiple devices (smartphones, smartwatches, etc.), making it easier to switch devices during a workout.',
    },
  ]
}

// Work
let Work_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ]
}

// TOZO Excellent Sound

// Superior Sound Quality
let superior_sound_quality_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enhanced Focus',
      content: 'Block out distracting background noise, whether you’re working, studying, or traveling.',
    },
    {
      id: 2,
      product: '',
      title: 'Improved Audio Quality',
      content: 'Experience crystal-clear sound without interference from your environment.',
    },
    {
      id: 3,
      product: '',
      title: 'Compact and Convenient',
      content: 'Lightweight and portable design makes them perfect for on-the-go lifestyles.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Work and Study',
      content: 'Create a quiet space for concentration in noisy offices or public spaces.',
    },
    {
      id: 2,
      product: '',
      title: 'Traveling',
      content: 'Reduce engine noise on planes or trains for a more comfortable journey.',
    },
    {
      id: 3,
      product: '',
      title: 'Fitness and Outdoors',
      content: 'Enjoy music or podcasts distraction-free during workouts or outdoor activities.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Noise-Canceling Performance',
      content: "Headphones offer superior noise cancellation for low frequencies, while earbuds are great for portable, everyday use.",
    },
    {
      id: 2,
      product: '',
      title: 'Comfort and Fit',
      content: 'Earbuds are lightweight and more comfortable for extended wear, whereas headphones may provide a snugger fit for longer listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Portability',
      content: 'Earbuds are more compact and travel-friendly, but headphones often deliver a more immersive audio experience.',
    },
  ],

  answer_type4: [
    
  ]
}

// Noise Canceling
let noise_canceling_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enhanced Focus',
      content: 'Block out distracting background noise, whether you’re working, studying, or traveling.',
    },
    {
      id: 2,
      product: '',
      title: 'Improved Audio Quality',
      content: 'Experience crystal-clear sound without interference from your environment.',
    },
    {
      id: 3,
      product: '',
      title: 'Compact and Convenient',
      content: 'Lightweight and portable design makes them perfect for on-the-go lifestyles.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Work and Study',
      content: 'Create a quiet space for concentration in noisy offices or public spaces.',
    },
    {
      id: 2,
      product: '',
      title: 'Traveling',
      content: 'Reduce engine noise on planes or trains for a more comfortable journey.',
    },
    {
      id: 3,
      product: '',
      title: 'Fitness and Outdoors',
      content: 'Enjoy music or podcasts distraction-free during workouts or outdoor activities.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Noise-Canceling Performance',
      content: "Headphones offer superior noise cancellation for low frequencies, while earbuds are great for portable, everyday use.",
    },
    {
      id: 2,
      product: '',
      title: 'Comfort and Fit',
      content: 'Earbuds are lightweight and more comfortable for extended wear, whereas headphones may provide a snugger fit for longer listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Portability',
      content: 'Earbuds are more compact and travel-friendly, but headphones often deliver a more immersive audio experience.',
    },
  ],

  answer_type4: [
    
  ]
}

// Long-lasting Battery
let long_lasting_battery_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enhanced Focus',
      content: 'Block out distracting background noise, whether you’re working, studying, or traveling.',
    },
    {
      id: 2,
      product: '',
      title: 'Improved Audio Quality',
      content: 'Experience crystal-clear sound without interference from your environment.',
    },
    {
      id: 3,
      product: '',
      title: 'Compact and Convenient',
      content: 'Lightweight and portable design makes them perfect for on-the-go lifestyles.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Work and Study',
      content: 'Create a quiet space for concentration in noisy offices or public spaces.',
    },
    {
      id: 2,
      product: '',
      title: 'Traveling',
      content: 'Reduce engine noise on planes or trains for a more comfortable journey.',
    },
    {
      id: 3,
      product: '',
      title: 'Fitness and Outdoors',
      content: 'Enjoy music or podcasts distraction-free during workouts or outdoor activities.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Noise-Canceling Performance',
      content: "Headphones offer superior noise cancellation for low frequencies, while earbuds are great for portable, everyday use.",
    },
    {
      id: 2,
      product: '',
      title: 'Comfort and Fit',
      content: 'Earbuds are lightweight and more comfortable for extended wear, whereas headphones may provide a snugger fit for longer listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Portability',
      content: 'Earbuds are more compact and travel-friendly, but headphones often deliver a more immersive audio experience.',
    },
  ],

  answer_type4: [
    
  ]
}

// Comfortable Fit
let comfortable_fit_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enhanced Focus',
      content: 'Block out distracting background noise, whether you’re working, studying, or traveling.',
    },
    {
      id: 2,
      product: '',
      title: 'Improved Audio Quality',
      content: 'Experience crystal-clear sound without interference from your environment.',
    },
    {
      id: 3,
      product: '',
      title: 'Compact and Convenient',
      content: 'Lightweight and portable design makes them perfect for on-the-go lifestyles.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Work and Study',
      content: 'Create a quiet space for concentration in noisy offices or public spaces.',
    },
    {
      id: 2,
      product: '',
      title: 'Traveling',
      content: 'Reduce engine noise on planes or trains for a more comfortable journey.',
    },
    {
      id: 3,
      product: '',
      title: 'Fitness and Outdoors',
      content: 'Enjoy music or podcasts distraction-free during workouts or outdoor activities.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Noise-Canceling Performance',
      content: "Headphones offer superior noise cancellation for low frequencies, while earbuds are great for portable, everyday use.",
    },
    {
      id: 2,
      product: '',
      title: 'Comfort and Fit',
      content: 'Earbuds are lightweight and more comfortable for extended wear, whereas headphones may provide a snugger fit for longer listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Portability',
      content: 'Earbuds are more compact and travel-friendly, but headphones often deliver a more immersive audio experience.',
    },
  ],

  answer_type4: [
    
  ]
}

// Work Headphones
let Work_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Active Noise Cancellation (ANC)',
      content: 'Opt for headphones with effective ANC to minimize ambient office noise, such as conversations and office equipment sounds, allowing for undisturbed concentration.',
    },
    {
      id: 2,
      product: '',
      title: 'Transparency Mode',
      content: 'Choose models with a transparency feature to stay aware of your surroundings when necessary, facilitating a balance between isolation and situational awareness.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Ergonomic Design',
      content: 'Select headphones with adjustable headbands and cushioned ear pads to ensure a comfortable fit during extended periods of use.',
    },
    {
      id: 2,
      product: '',
      title: 'Lightweight Construction',
      content: 'Lightweight headphones reduce pressure on the head and ears, enhancing comfort during long work sessions.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Clear Audio',
      content: "High-fidelity sound enhances the clarity of virtual meetings and multimedia content, ensuring effective communication.",
    },
    {
      id: 2,
      product: '',
      title: 'Microphone Quality',
      content: 'Integrated microphones with noise-canceling features ensure your voice is heard clearly during calls, minimizing misunderstandings.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Multi-Device Pairing',
      content: 'Headphones that support simultaneous connections to multiple devices, such as computers and smartphones, offer flexibility in managing different work tools.',
    },
    {
      id: 2,
      product: '',
      title: 'Extended Battery Life',
      content: 'Long-lasting battery performance, ideally 8+ hours, supports full workdays without frequent recharging, ensuring uninterrupted use.',
    },
  ]
}

// Travel Headphones
let Travel_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Fit & Comfort',
      content: 'Opt for ergonomic designs that provide a snug fit, such as over-ear headphones with adjustable headbands or in-ear earbuds with customizable ear gels. A proper fit ensures the headphones remain comfortable during extended periods of use, which is crucial during long flights or commutes.',
    },
    {
      id: 2,
      product: '',
      title: 'Fit Stability',
      content: 'Choose headphones that stay securely in place, especially during movement. Features like ear hooks or winged tips can enhance stability, preventing the need for constant adjustments.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Sweat & Water Resistance',
      content: 'Select headphones with at least an IPX4 rating to ensure they can withstand sweat and moisture, making them suitable for various travel conditions.',
    },
    {
      id: 2,
      product: '',
      title: 'Durability',
      content: 'Look for headphones with a rugged build that resists drops and scratches, ensuring long-lasting performance, especially in outdoor or high-impact environments.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Battery Life',
      content: "Opt for models with extended battery life, ideally 20 to 30 hours, to last through long flights or multiple travel days without frequent charging.",
    },
    {
      id: 2,
      product: '',
      title: 'Charging Efficiency',
      content: 'Some headphones offer quick charging capabilities, providing several hours of use with just a short charging time—beneficial for frequent travelers.',
    },
    {
      id: 3,
      product: '',
      title: 'Control Features',
      content: 'Easy-to-use on-device controls or integration with voice assistants allow you to adjust music volume or take calls without interrupting your activities.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Sound Quality',
      content: 'Clear sound with strong bass can enhance your travel experience, delivering immersive audio for music, podcasts, or movies.',
    },
    {
      id: 2,
      product: '',
      title: 'Connectivity',
      content: 'Wireless headphones with Bluetooth 5.3 or higher ensure stable connectivity, especially in crowded areas like airports or public transport.',
    },
    {
      id: 3,
      product: '',
      title: 'Device Compatibility',
      content: 'Ensure the headphones are compatible with multiple devices (smartphones, tablets, laptops), making it easier to switch between devices during your travels.',
    },
  ]
}
// Over-Ear Headphones
let Over_Ear_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Driver Technology',
      content: 'High-quality drivers are crucial for clear and balanced sound.',
    },
    {
      id: 2,
      product: '',
      title: 'Frequency Response',
      content: 'A wide frequency range allows for a more detailed reproduction of audio, capturing both deep bass and high treble notes.',
    },
    {
      id: 3,
      product: '',
      title: 'Total Harmonic Distortion (THD)',
      content: 'Lower THD values indicate less distortion at high volumes, ensuring the sound remains clear and accurate.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Ear Cushion Material',
      content: 'Soft, breathable materials like memory foam covered with leather or velour enhance comfort and reduce heat buildup during extended use.',
    },
    {
      id: 2,
      product: '',
      title: 'Adjustable Headband',
      content: 'An easily adjustable headband ensures a secure fit for different head sizes, preventing discomfort or pressure points.',
    },
    {
      id: 3,
      product: '',
      title: 'Weight',
      content: 'Lightweight designs minimize strain on the head and neck, making them suitable for prolonged listening sessions.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Active Noise Cancellation (ANC)',
      content: 'This technology uses microphones to detect and counteract external noise, providing a more immersive listening environment. effectively reducing ambient sounds during travel or in noisy environments.',
    },
    {
      id: 2,
      product: '',
      title: 'Passive Noise Isolation',
      content: 'Well-designed ear cups that seal around the ears can naturally block out ambient sounds without electronic intervention.',
    },
    {
      id: 3,
      product: '',
      title: 'Transparency Mode',
      content: 'Some headphones offer a mode that allows external sounds in, enabling awareness of your surroundings when needed.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Battery Longevity',
      content: 'For wireless models, consider headphones that offer extended battery life to reduce frequent charging.',
    },
    {
      id: 2,
      product: '',
      title: 'Fast Charging Capability',
      content: 'Features like quick charge can provide several hours of playback with just a short charging time.',
    },
    {
      id: 3,
      product: '',
      title: 'Bluetooth Version and Codecs',
      content: 'Ensure the headphones support the latest Bluetooth versions and high-quality audio codecs (e.g., aptX, AAC) for stable connections and better sound quality.',
    },
  ]
}

// Waterproof Earbuds
let Waterproof_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'IPX Rating System',
      content: 'The Ingress Protection (IP) rating indicates the level of protection against solids and liquids. For example, an IPX7 rating means the device can withstand immersion in water up to 1 meter for 30 minutes, while IPX4 offers protection against splashes from any direction.',
    },
    {
      id: 2,
      product: '',
      title: 'Dust Protection',
      content: 'The first digit in an IP rating denotes protection against solids like dust. An IP6X rating signifies complete dust-tight protection, crucial for maintaining functionality in dusty environments.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Driver Technology',
      content: 'High-quality drivers are essential for clear and balanced sound.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Isolation and Cancellation',
      content: 'Effective passive noise isolation, achieved through well-fitted ear tips, can enhance sound quality by minimizing external distractions.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Ear Tip Design',
      content: 'Earbuds with multiple ear tip sizes ensure a secure and comfortable fit, crucial for extended use and maintaining sound quality.',
    },
    {
      id: 2,
      product: '',
      title: 'Stability Features',
      content: 'For active users, features like ear hooks or wings provide additional stability during workouts or movement-intensive activities. ',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Battery Longevity',
      content: 'Consider earbuds with extended battery life to reduce frequent charging.',
    },
    {
      id: 2,
      product: '',
      title: 'Connectivity Options',
      content: 'Ensure the earbuds support stable Bluetooth connections and are compatible with your devices. Features like multipoint pairing can be advantageous for seamless switching between devices.',
    },
  ]
}

// Open Ear Headphones
let Open_Ear_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Wide Frequency Range',
      content: 'Open-ear headphones should offer a broad frequency range for rich, balanced sound. The more extended the range, the better the audio performance across all frequencies, from deep bass to crisp highs.',
    },
    {
      id: 2,
      product: '',
      title: 'Audio Drivers',
      content: 'Look for headphones with high-quality drivers. Larger drivers or dual drivers can provide clearer, more immersive sound.',
    },
    {
      id: 3,
      product: '',
      title: 'Open-Back Design',
      content: ' The open-back design ensures a natural soundstage and an airy listening experience. It allows you to hear a more realistic blend of sounds, though it may not block external noise as much as over-ear headphones. This is perfect for listening while remaining aware of your surroundings.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Lightweight Construction',
      content: 'Open-ear headphones are typically lighter than traditional over-ear models. Their lightweight design reduces head and neck fatigue, making them ideal for long listening sessions.',
    },
    {
      id: 2,
      product: '',
      title: 'Secure Fit for Movement',
      content: 'Ensure the headphones have a secure fit, especially if you plan to use them for workouts or outdoor activities. Adjustable headbands and soft ear hooks or wings can keep the headphones in place during physical movement.',
    },
    {
      id: 3,
      product: '',
      title: 'Breathable Materials',
      content: 'Comfortable padding or mesh materials around the ear and headband allow for breathability, preventing heat build-up during long periods of use. This is especially important if you plan to wear them for hours.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth and Multipoint Pairing',
      content: 'Ensure the headphones have Bluetooth support for wireless convenience. Some models offer multipoint pairing, allowing you to connect to multiple devices simultaneously (e.g., phone and computer), which adds to usability.',
    },
    {
      id: 2,
      product: '',
      title: 'Audio Controls and Voice Assistance',
      content: 'Look for headphones with easy-to-use controls, like volume adjustment, play/pause, and track skipping. Built-in voice assistants can also be a nice feature for hands-free operation.',
    },
    {
      id: 3,
      product: '',
      title: 'Water Resistance',
      content: 'For outdoor use, make sure the headphones have some level of water resistance, like an IPX4 or higher rating. This ensures the headphones can withstand sweat, rain, or splashes during activities such as running or cycling.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Extended Battery Life',
      content: 'Look for open-ear headphones with long battery life for continuous listening. Models like the NC9 offer up to 8 hours of battery life, which is great for long workouts or commutes.',
    },
    {
      id: 2,
      product: '',
      title: 'Fast Charging',
      content: "Consider headphones with quick charging capabilities. Many models offer an hour or more of use after just a short charging time, which is helpful if you're short on time.",
    },
    {
      id: 3,
      product: '',
      title: 'Durability and Build Quality',
      content: 'The build quality of open-ear headphones is important, especially if you use them outdoors. Make sure they are made with durable materials that can withstand physical activity and occasional drops. High-quality construction ensures longevity and performance.',
    },
  ]
}

// Ture Wireless Earbuds
let Ture_Wireless_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Driver Quality',
      content: 'High-quality drivers enhance sound clarity and bass. Larger drivers often provide better bass response, while advanced technologies improve overall audio performance.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Cancellation',
      content: 'Active Noise Cancellation (ANC) reduces background noise by using microphones and sound waves, allowing for an immersive listening experience in noisy environments.',
    },
    {
      id: 3,
      product: '',
      title: 'Frequency Range',
      content: 'A broader frequency range enables earbuds to reproduce richer, more dynamic sound, capturing both deep bass and high treble for a balanced audio experience across various music genres.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Ear Tip Options',
      content: 'Choose earbuds with multiple silicone or foam ear tip sizes for a secure, comfortable fit, enhancing sound quality and noise isolation during extended listening.',
    },
    {
      id: 2,
      product: '',
      title: 'Ergonomic Design',
      content: 'Select earbuds with ergonomic shapes that fit naturally in the ear, ensuring comfort during prolonged use.',
    },
    {
      id: 3,
      product: '',
      title: 'Secure Fit for Active Use',
      content: 'For physical activities, opt for earbuds with stabilizing features like ear hooks or fins to prevent them from falling out during intense movement.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Battery Longevity',
      content: 'Choose earbuds offering extended battery life, like models providing up to 15 hours on a single charge, ensuring uninterrupted listening during travel or long use.',
    },
    {
      id: 2,
      product: '',
      title: 'Charging Case',
      content: 'Select earbuds with a high-capacity charging case, enabling multiple recharges on the go. Fast-charging cases can provide hours of playback with just a short charge.',
    },
    {
      id: 3,
      product: '',
      title: 'Wireless Charging',
      content: 'Opt for earbuds supporting wireless charging for added convenience, allowing you to recharge the case using compatible wireless charging pads, reducing cable clutter.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth Range and Stability',
      content: 'Opt for earbuds with Bluetooth 5.0 or higher for faster pairing, extended range, and stable connections, ensuring smooth performance during calls and audio streaming.',
    },
    {
      id: 2,
      product: '',
      title: 'Multi-Device Pairing',
      content: 'This feature allows seamless switching between devices like phones and laptops without repeated pairing, enhancing convenience.',
    },
    {
      id: 3,
      product: '',
      title: 'Voice Assistant Integration',
      content: 'Earbuds with built-in support for Siri, Google Assistant, or Alexa enable hands-free control for tasks like adjusting volume, skipping tracks, or making calls.',
    },
  ]
}

// Hi Res Audio Headphones
let Hi_Res_Audio_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'High-Resolution Audio Support',
      content: 'Headphones must support at least 24-bit depth and 96kHz sampling rates to qualify as Hi-Res Audio, ensuring they capture subtle details that standard headphones may miss.',
    },
    {
      id: 2,
      product: '',
      title: 'Driver Technology',
      content: 'Hi-Res Audio headphones often utilize advanced drivers like planar magnetic or electrostatic types, offering enhanced sound clarity and bass response.',
    },
    {
      id: 3,
      product: '',
      title: 'Frequency Range',
      content: 'These headphones typically feature a wider frequency range, often 20Hz to 40kHz, accurately reproducing both deep bass and high treble for a comprehensive listening experience.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Headband and Ear Cup Design',
      content: 'Adjustable headbands and cushioned ear cups, often with memory foam, ensure a secure, comfortable fit for prolonged listening sessions.',
    },
    {
      id: 2,
      product: '',
      title: 'Weight and Build',
      content: 'Durable yet lightweight materials like aluminum or high-quality plastics prevent fatigue during extended use.',
    },
    {
      id: 3,
      product: '',
      title: 'Ear Padding and Seal',
      content: 'Memory foam or plush ear pads create a proper seal, minimizing external noise and enhancing sound quality for a richer listening experience.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Wired vs Wireless',
      content: 'Wired headphones offer superior audio fidelity, while wireless ones provide convenience but may compromise sound quality due to Bluetooth compression.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Cancellation or Isolation',
      content: ' Active Noise Cancellation (ANC) reduces external sounds electronically, enhancing immersion. Passive isolation relies on design and materials to block noise.',
    },
    {
      id: 3,
      product: '',
      title: 'Bluetooth and Codec Support',
      content: 'For wireless Hi-Res audio, ensure headphones support high-definition codecs like LDAC or aptX HD for better sound quality.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Build Quality',
      content: 'Opt for headphones made with durable materials like aluminum or titanium for longevity. Foldable designs enhance portability without compromising structural integrity.',
    },
    {
      id: 2,
      product: '',
      title: 'Battery Life (for Wireless Models)',
      content: 'Select wireless headphones offering 20-30 hours of playback per charge. Rapid charging features provide quick usability during extended listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'IP Rating for Water Resistance',
      content: 'For outdoor or exercise use, choose headphones with a high IP rating (e.g., IPX5 or IPX7) to ensure resistance to sweat and rain.',
    },
  ]
}

// Comfortable Headphones
let Comfortable_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Memory Foam or Plush Padding',
      content: 'Look for headphones with memory foam or plush padding that adapts to ear shape, reducing pressure and providing comfort during extended listening sessions.',
    },
    {
      id: 2,
      product: '',
      title: 'Over-Ear vs On-Ear Design',
      content: 'Over-ear headphones offer better comfort by covering the ears and isolating noise. On-ear models are lighter but may cause discomfort during long use. Test fit before buying.',
    },
    {
      id: 3,
      product: '',
      title: 'Breathable Materials',
      content: 'Choose headphones with breathable ear cups made of mesh or fabric to prevent heat buildup and sweat, ensuring comfort during long sessions or workouts.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Adjustable Headband',
      content: 'Choose headphones with an adjustable headband made of soft materials like memory foam or padded fabric for a custom fit and even pressure distribution, ensuring comfort during extended use.',
    },
    {
      id: 2,
      product: '',
      title: 'Secure Fit',
      content: 'A secure, adjustable headband ensures a snug fit. Avoid loose headphones that slide off or tight ones causing discomfort. The goal is a comfortable, firm hold during movement or exercise.',
    },
    {
      id: 3,
      product: '',
      title: 'Weight Distribution',
      content: 'Look for headphones with even weight distribution to avoid pressure buildup. Lighter materials like plastic or aluminum provide durability without bulk, ensuring a secure fit without discomfort.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Active Noise Cancellation (ANC)',
      content: 'ANC blocks external noise, improving comfort and focus, especially in noisy environments like coffee shops or offices. It reduces the need for high volume, making listening more relaxing.',
    },
    {
      id: 2,
      product: '',
      title: 'Passive Noise Isolation',
      content: 'Over-ear headphones offer passive noise isolation by covering your ears, blocking ambient noise without relying on ANC. Ideal for those who want distraction-free listening without battery usage.',
    },
    {
      id: 3,
      product: '',
      title: 'Noise Leakage Prevention',
      content: 'Headphones with a tight-fitting design prevent sound leakage, ensuring private listening without disturbing others. Look for well-sealed headphones that balance comfort and noise isolation.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Sturdy but Lightweight Construction',
      content: 'Look for headphones made with high-quality plastics, aluminum, or steel for durability without added weight. A well-built frame ensures long-lasting comfort without being too heavy.',
    },
    {
      id: 2,
      product: '',
      title: 'Collapsible or Foldable Design',
      content: 'Collapsible or foldable headphones are easy to store and transport, reducing the risk of damage during travel. Great for on-the-go users or commuters.',
    },
    {
      id: 3,
      product: '',
      title: 'Sweat and Water Resistance',
      content: 'For workouts or outdoor activities, choose sweat- and water-resistant headphones with an IPX rating to ensure durability and comfort in various conditions. Ideal for athletes or active users.',
    },
  ]
}

// Gaming Headphones
let Gaming_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'High-Resolution Audio',
      content: 'For clear, detailed sound that enhances your gaming experience, look for headphones with high-resolution audio for immersive sound. It provides clarity for in-game details.',
    },
    {
      id: 2,
      product: '',
      title: 'Surround Sound Capability',
      content: 'Headphones with surround sound (e.g., Dolby Atmos) can simulate 3D sound, helping you pinpoint enemy positions and adding depth to your gaming world.',
    },
    {
      id: 3,
      product: '',
      title: 'Deep Bass Response',
      content: 'Powerful bass is essential for a more dynamic experience, adding impact to explosions, gunshots, and other action-packed moments in the game.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Padded Ear Cups',
      content: 'Look for soft, plush ear cups with memory foam to reduce pressure and enhance comfort during long gaming sessions. This prevents ear fatigue.',
    },
    {
      id: 2,
      product: '',
      title: 'Adjustable Headband',
      content: 'An adjustable, cushioned headband provides a secure yet comfortable fit, allowing you to play for hours without discomfort.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight Design',
      content: 'Choose lightweight gaming headphones that won’t weigh you down after long hours of play, ensuring that you stay comfortable throughout your gaming sessions.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Noise-Canceling Microphone',
      content: 'A noise-canceling microphone ensures clear communication by filtering out background noise, essential for team-based or online gaming.',
    },
    {
      id: 2,
      product: '',
      title: 'Detachable Mic',
      content: 'A detachable microphone offers flexibility, letting you remove it when not needed, reducing distractions during single-player sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Adjustable Mic Position',
      content: 'Headphones with a flexible or adjustable mic ensure the best voice clarity, letting you place it closer to your mouth for clearer communication.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Sturdy Construction',
      content: 'Gaming headphones should be made from durable materials like aluminum or high-grade plastic, ensuring they withstand rough use without breaking.',
    },
    {
      id: 2,
      product: '',
      title: 'Flexible and Foldable Design',
      content: 'Foldable designs make storage easier, while flexible hinges allow the headphones to be adjusted for comfort without damaging the frame.',
    },
    {
      id: 3,
      product: '',
      title: 'Sweat and Water Resistance',
      content: 'Gaming headphones with water or sweat resistance provide added durability, especially useful during intense gaming sessions or for long wear.',
    },
  ]
}

// Long Battery Life Earbuds
let Long_Battery_Life_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Higher mAh Rating',
      content: 'Look for earbuds with higher battery capacity (mAh) for longer playtime, ensuring uninterrupted listening during commutes or workouts.',
    },
    {
      id: 2,
      product: '',
      title: 'Quick Charging Feature',
      content: "Earbuds with fast charging capabilities are ideal for quick top-ups when you're in a rush, offering hours of playback in just a short charging period.",
    },
    {
      id: 3,
      product: '',
      title: 'Long Standby Time',
      content: 'Ensure the earbuds have a long standby time, so they conserve battery when not in use, allowing for longer shelf life between uses.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Large Charging Case Battery',
      content: 'A charging case with a larger battery extends the overall usage time, giving your earbuds multiple charges while traveling.',
    },
    {
      id: 2,
      product: '',
      title: 'Portable Design',
      content: 'Opt for a compact, easy-to-carry charging case that allows you to recharge your earbuds while on the go without taking up too much space.',
    },
    {
      id: 3,
      product: '',
      title: 'Wireless Charging Support',
      content: 'Some charging cases support wireless charging, making it easier to top up your earbuds without needing cables, especially when traveling.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Low Power Consumption',
      content: 'Earbuds with low power consumption ensure long-lasting battery life without compromising performance, offering you more hours of use.',
    },
    {
      id: 2,
      product: '',
      title: 'Adaptive Power Management',
      content: 'Smart earbuds adjust power usage based on activity (e.g., listening vs. standby) to maximize battery life throughout the day.',
    },
    {
      id: 3,
      product: '',
      title: 'Bluetooth Version Efficiency',
      content: 'Newer Bluetooth versions (e.g., 5.0) offer more efficient power management, extending battery life while maintaining strong connectivity.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Active Noise Cancellation (ANC) Impact',
      content: 'ANC can drain battery life faster, so choose earbuds with an efficient ANC system to balance sound quality and battery longevity.',
    },
    {
      id: 2,
      product: '',
      title: 'Touch Controls and Voice Assistant',
      content: 'Features like touch controls and voice assistants can consume more power, so ensure the earbuds are optimized to balance performance and battery life.',
    },
    {
      id: 3,
      product: '',
      title: 'Waterproof Rating',
      content: 'Earbuds with a high waterproof rating (IPX7 or above) tend to have better power efficiency, protecting the battery from moisture damage while in use.',
    },
  ]
}

// Translate Earbuds
let Translate_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Advanced Translation Algorithms',
      content: 'Look for earbuds with AI-driven translation algorithms for accurate, real-time speech translation, reducing errors during communication.',
    },
    {
      id: 2,
      product: '',
      title: 'Multi-Language Support',
      content: 'Ensure the earbuds support a wide range of languages for seamless communication across different cultures.',
    },
    {
      id: 3,
      product: '',
      title: 'Low Latency',
      content: 'Opt for earbuds with low-latency translation to minimize delays and make conversations feel more natural.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth Connectivity',
      content: 'Choose earbuds with stable Bluetooth 5.0 or higher for a seamless connection with smartphones or translation apps without interference.',
    },
    {
      id: 2,
      product: '',
      title: 'App Compatibility',
      content: 'Make sure the earbuds work with popular translation apps for enhanced functionality and language flexibility.',
    },
    {
      id: 3,
      product: '',
      title: 'Multi-Device Pairing',
      content: 'Select earbuds that allow simultaneous connection to multiple devices, providing convenience when switching between different communication platforms.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Ergonomic Design',
      content: 'Earbuds with a comfortable, ergonomic fit help reduce ear strain, making them ideal for long hours of use during translation.',
    },
    {
      id: 2,
      product: '',
      title: 'Secure Fit',
      content: 'Look for earbuds that stay securely in place, especially when using them during travel or active conversations.',
    },
    {
      id: 3,
      product: '',
      title: 'Multiple Ear Tip Sizes',
      content: 'Choose earbuds with a variety of ear tip sizes to ensure a snug fit and optimal sound quality during translation. ',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Long Battery Life',
      content: 'Long-lasting battery life is crucial for extended translation sessions, so choose earbuds that provide hours of usage on a single charge.',
    },
    {
      id: 2,
      product: '',
      title: 'Quick Charging',
      content: 'Fast-charging earbuds are essential for a quick turnaround, ensuring you have power when you need it most.',
    },
    {
      id: 3,
      product: '',
      title: 'Portable Charging Case',
      content: 'A portable charging case ensures your earbuds are always ready to go, allowing you to recharge them on the move during trips. ',
    },
  ]
}

// Sleep Headphones
let Sleep_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Soft and Padded Ear Cups',
      content: 'Choose sleep headphones with soft, memory foam ear cups or fabric that minimize pressure and ensure comfort through the night.',
    },
    {
      id: 2,
      product: '',
      title: 'Headband or Strap Design',
      content: 'Headband-style sleep headphones are great for keeping the earbuds in place without causing ear discomfort, ideal for side sleepers.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight Design',
      content: 'Opt for lightweight headphones that won’t feel heavy or bulky, allowing you to rest without distractions throughout the night.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Noise-Canceling Features',
      content: 'Noise-canceling headphones help block out background noise, allowing for a more peaceful sleep by reducing disturbances.',
    },
    {
      id: 2,
      product: '',
      title: 'Soothing Sound Quality',
      content: 'Look for headphones that provide high-quality sound, ideal for soothing music or white noise that helps you fall asleep faster.',
    },
    {
      id: 3,
      product: '',
      title: 'Adjustable Volume',
      content: 'Adjustable volume control helps you set the perfect sound level, so it’s not too loud or quiet to disrupt your sleep.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Extended Battery Life',
      content: 'Sleep headphones with long battery life ensure you can use them for the entire night without needing to recharge.',
    },
    {
      id: 2,
      product: '',
      title: 'Quick Charging',
      content: 'Quick-charging capabilities allow you to top up your headphones in a short time, ensuring you never run out of power before sleep.',
    },
    {
      id: 3,
      product: '',
      title: 'Low Power Mode',
      content: 'Look for sleep headphones with energy-saving features to extend battery life and reduce the need for frequent charging.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Durable Build',
      content: ' Sleep headphones should be built to withstand regular use, especially if you plan to use them nightly. Look for strong, flexible materials.',
    },
    {
      id: 2,
      product: '',
      title: 'Washable Fabric',
      content: 'Choose sleep headphones with removable, washable covers, so you can keep them fresh and clean, ensuring hygiene over time.',
    },
    {
      id: 3,
      product: '',
      title: 'Sweat and Moisture Resistance',
      content: 'Sleep headphones should resist sweat and moisture, ensuring durability even if you use them during workouts or while you sleep.',
    },
  ]
}

// Kids Headphones
let Kids_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Volume-Limiting Technology',
      content: 'Look for headphones with built-in volume limits (85-90dB), which protect kids’ hearing by preventing dangerously loud audio levels.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise-Canceling for Quiet Environments',
      content: 'Noise-canceling headphones reduce external noise, allowing children to enjoy audio at lower, safer volumes.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight and Comfortable Design',
      content: 'Choose lightweight headphones to prevent strain on kids’ ears, offering comfort for long listening sessions.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Built for Tough Use',
      content: 'Headphones designed for kids should be durable, with strong materials that can withstand rough handling, drops, or accidental bending.',
    },
    {
      id: 2,
      product: '',
      title: 'Adjustable Headband',
      content: "Adjustable headbands ensure a comfortable fit for growing kids, accommodating different head sizes and improving the headphones' lifespan.",
    },
    {
      id: 3,
      product: '',
      title: 'Tangle-Free Cables or Wireless Design',
      content: 'Choose wireless or tangle-free cables for ease of use, preventing frustration with tangled wires.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Soft Ear Cushions',
      content: 'Look for headphones with soft, padded ear cushions to enhance comfort and prevent ear pain during extended use.',
    },
    {
      id: 2,
      product: '',
      title: 'Adjustable Fit',
      content: 'Adjustable headbands and earcups allow for a custom fit, ensuring comfort as kids grow and providing a snug fit.',
    },
    {
      id: 3,
      product: '',
      title: 'Breathable Materials',
      content: 'Headphones made from breathable materials prevent overheating, ensuring kids’ ears stay cool and comfortable.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Fun Colors and Styles',
      content: 'Choose headphones with vibrant colors and fun designs to make them more appealing to kids, encouraging usage.',
    },
    {
      id: 2,
      product: '',
      title: 'Simple Controls',
      content: 'Kid-friendly headphones should have easy-to-use buttons or touch controls, so children can adjust volume or skip tracks independently.',
    },
    {
      id: 3,
      product: '',
      title: 'Foldable and Portable',
      content: 'Foldable designs make storage easy, so kids can carry their headphones around without taking up too much space.',
    },
  ]
}

// IPX7 Waterproof Earbuds
let IPX7_Waterproof_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Secure Fit',
      content: 'Ear hooks or ergonomic designs prevent slipping during movement.',
    },
    {
      id: 2,
      product: '',
      title: 'Sweat Resistance',
      content: 'Materials designed to withstand perspiration.',
    },
    {
      id: 3,
      product: '',
      title: 'BatteryLife',
      content: 'Extended playtime to last through long workouts.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Noise Cancellation',
      content: 'Active or passive features to reduce ambient noise.',
    },
    {
      id: 2,
      product: '',
      title: 'Compact Design',
      content: 'Easily portable and pocket-friendly.',
    },
    {
      id: 3,
      product: '',
      title: 'Quick Charging',
      content: 'Fast charging capabilities for on-the-go use.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Sound Quality',
      content: ' High-fidelity audio with deep bass and clear treble.',
    },
    {
      id: 2,
      product: '',
      title: 'Codec Support',
      content: 'Compatibility with advanced audio codecs like aptX or AAC.',
    },
    {
      id: 3,
      product: '',
      title: 'Driver Size',
      content: 'Larger drivers for a richer sound experience.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Affordable Pricing',
      content: 'High-quality features at a competitive price point.',
    },
    {
      id: 2,
      product: '',
      title: 'Durability',
      content: 'Long-lasting build to ensure value over time.',
    },
    {
      id: 3,
      product: '',
      title: 'Warranty',
      content: 'Comprehensive coverage for peace of mind.',
    },
  ]
}

// IPX8 Waterproof Earbuds
let IPX8_Waterproof_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: '',
      content: 'Ergonomic design for secure fit.',
    },
    {
      id: 2,
      product: '',
      title: '',
      content: 'Multiple ear tip sizes included.',
    },
    {
      id: 3,
      product: '',
      title: '',
      content: 'Lightweight for extended wear.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: '',
      content: 'Long-lasting playtime per charge.',
    },
    {
      id: 2,
      product: '',
      title: '',
      content: 'Quick charging capabilities.',
    },
    {
      id: 3,
      product: '',
      title: '',
      content: 'Charging case for on-the-go power.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: '',
      content: 'Advanced drivers for deep bass.',
    },
    {
      id: 2,
      product: '',
      title: '',
      content: 'Noise isolation for clear sound.',
    },
    {
      id: 3,
      product: '',
      title: '',
      content: 'Stable Bluetooth connectivity.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: '',
      content: 'Touch controls for easy operation.',
    },
    {
      id: 2,
      product: '',
      title: '',
      content: 'Voice assistant compatibility.',
    },
    {
      id: 3,
      product: '',
      title: '',
      content: 'Built-in microphone for calls.',
    },
  ]
}

// IPX6 Earbuds
let IPX6_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'High-Fidelity Audio',
      content: 'Look for earbuds that deliver clear and balanced sound.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Isolation',
      content: 'Ensure they can block out ambient noise effectively.',
    },
    {
      id: 3,
      product: '',
      title: 'Bass Performance',
      content: 'Consider earbuds with enhanced bass for a richer experience.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Ergonomic Design',
      content: 'Choose earbuds that fit securely without causing discomfort.',
    },
    {
      id: 2,
      product: '',
      title: 'Multiple Ear Tip Sizes',
      content: 'Options allow for a customized fit.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight Build',
      content: 'Reduces ear fatigue during extended use.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Long-Lasting Charge',
      content: 'Opt for earbuds offering extended playback time.',
    },
    {
      id: 2,
      product: '',
      title: 'Quick Charging',
      content: 'Features that allow rapid battery replenishment are beneficial.',
    },
    {
      id: 3,
      product: '',
      title: 'Battery Indicator',
      content: 'Helps monitor remaining power easily.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Stable Bluetooth Connection',
      content: ' Ensures uninterrupted audio streaming.',
    },
    {
      id: 2,
      product: '',
      title: 'Compatibility',
      content: 'Check for compatibility with your devices.',
    },
    {
      id: 3,
      product: '',
      title: 'Low Latency',
      content: 'Important for video watching and gaming.',
    },
  ]
}

// Behind the Ear Headphones
let Behind_the_Ear_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Comfortable Design',
      content: 'Behind the ear headphones are engineered for comfort during long listening sessions, with soft ear hooks or ergonomic designs that don’t cause discomfort.',
    },
    {
      id: 2,
      product: '',
      title: 'Stability',
      content: 'The design prevents slipping, making them ideal for active users who need headphones that stay in place during intense movement.',
    },
    {
      id: 3,
      product: '',
      title: 'Adjustable Fit',
      content: 'Look for headphones with adjustable ear tips or loops to customize the fit to your head for maximum comfort.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Crystal Clear Audio',
      content: 'Premium models offer excellent sound quality with deep bass, crisp highs, and balanced mids, enhancing your listening experience.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Isolation',
      content: 'Look for headphones that provide good passive noise isolation, keeping out ambient noise during commutes or workouts.',
    },
    {
      id: 3,
      product: '',
      title: 'Low Latency',
      content: 'Bluetooth models with low latency ensure there’s no delay between audio and video, perfect for watching movies or gaming.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Water Resistance',
      content: 'IPX6 rated models are resistant to sweat, rain, and even splashes, making them reliable for all types of physical activity.',
    },
    {
      id: 2,
      product: '',
      title: 'Lightweight Build',
      content: 'Look for lightweight materials such as aluminum or high-quality plastics to ensure the headphones remain comfortable for long periods.',
    },
    {
      id: 3,
      product: '',
      title: 'Sturdy Design',
      content: 'Durability is key for long-lasting performance, especially if you’re using the headphones outdoors or during intense activities.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Stable Wireless Connection',
      content: 'Look for Bluetooth 5.0 or newer for a stable connection with minimal interference.',
    },
    {
      id: 2,
      product: '',
      title: 'Extended Range',
      content: 'A long wireless range ensures uninterrupted audio, even if you move around the room or area.',
    },
    {
      id: 3,
      product: '',
      title: 'Easy Pairing',
      content: 'Make sure the headphones are easy to pair with your devices, with multi-point pairing options for seamless device switching.',
    },
  ]
}

// Foldable Headphones
let Foldable_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Clear Audio',
      content: 'Choose headphones with high-quality drivers to ensure clear, crisp sound for music, calls, and media.',
    },
    {
      id: 2,
      product: '',
      title: 'Bass Response',
      content: 'Consider headphones with enhanced bass for a richer listening experience, especially for bass-heavy genres.',
    },
    {
      id: 3,
      product: '',
      title: 'Balanced Audio',
      content: 'Look for headphones with a balanced audio profile, covering both high and low frequencies for an immersive experience.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Adjustable Headbands',
      content: 'Ensure the headphones have an adjustable headband to suit different head sizes.',
    },
    {
      id: 2,
      product: '',
      title: 'Padded Ear Cups',
      content: 'Soft, padded ear cups help enhance comfort, especially for long listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight Design',
      content: 'Lightweight foldable headphones reduce pressure on the ears and head, offering comfort during extended use.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Sturdy Construction',
      content: 'Choose headphones made of high-quality materials like metal or reinforced plastic to ensure durability.',
    },
    {
      id: 2,
      product: '',
      title: 'Foldable Design',
      content: 'The foldable design prevents damage and makes it easy to store when not in use.',
    },
    {
      id: 3,
      product: '',
      title: 'Water and Sweat Resistance',
      content: 'Opt for models with a high IP rating to withstand sweat and moisture, ideal for outdoor use or workouts.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Wireless Connectivity',
      content: 'Look for Bluetooth-enabled foldable headphones for freedom of movement and seamless connections.',
    },
    {
      id: 2,
      product: '',
      title: 'Wired Options',
      content: 'Some foldable models also offer wired connectivity for situations where Bluetooth is not available.',
    },
    {
      id: 3,
      product: '',
      title: 'Multi-device Pairing',
      content: 'Consider headphones with multi-point Bluetooth support to connect to multiple devices at once.',
    },
  ]
}

// Premium Headphones
let Premium_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Driver Size & Type',
      content: 'Larger drivers deliver deeper bass and richer sound.',
    },
    {
      id: 2,
      product: '',
      title: 'Frequency Range',
      content: 'Wider range means better highs and lows.',
    },
    {
      id: 3,
      product: '',
      title: 'Codec Support',
      content: 'LDAC or aptX HD ensures high-fidelity wireless audio.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'ANC or Passive Isolation',
      content: 'ANC blocks noise; passive designs isolate naturally.',
    },
    {
      id: 2,
      product: '',
      title: 'Fit & Seal',
      content: 'A tight seal improves bass and blocks outside sound.',
    },
    {
      id: 3,
      product: '',
      title: 'Leakage Prevention',
      content: 'Ensures privacy and avoids disturbing others nearby.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Adjustable Headband',
      content: 'Adapts to your head shape for long-term use.',
    },
    {
      id: 2,
      product: '',
      title: 'Ear Padding',
      content: 'Memory foam reduces pressure for extended wear.',
    },
    {
      id: 3,
      product: '',
      title: 'Weight Distribution',
      content: 'Even design prevents pressure buildup on the head.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Battery Life',
      content: 'Look for 20+ hours with quick charging support.',
    },
    {
      id: 2,
      product: '',
      title: 'Water Resistance',
      content: 'IPX-rated models handle sweat and rain easily.',
    },
    {
      id: 3,
      product: '',
      title: 'Portablity',
      content: 'Foldable or compact models are perfect for on-the-go use.',
    },
  ]
}

// Black Headphones
let Black_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'High-Fidelity Audio',
      content: 'Look for headphones with Hi-Res certification for superior sound reproduction.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Cancellation',
      content: 'Active noise cancelling features ensure an immersive listening experience.',
    },
    {
      id: 3,
      product: '',
      title: 'Bass Performance',
      content: 'Enhanced bass drivers provide depth for genres like EDM and hip-hop.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Ergonomic Design',
      content: 'Adjustable headbands and cushioned ear cups for prolonged use.',
    },
    {
      id: 2,
      product: '',
      title: 'Lightweight Build',
      content: 'Reduces strain during extended listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Secure Fit',
      content: 'Ensures stability during activities like workouts or commuting.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Long Playtime',
      content: 'Opt for models offering 30+ hours of battery life.',
    },
    {
      id: 2,
      product: '',
      title: 'Fast Charging',
      content: 'Quick charge features provide hours of use with minimal charging time.',
    },
    {
      id: 3,
      product: '',
      title: 'Wireless Charging',
      content: 'Convenient charging without the hassle of cables.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth 5.0 or Higher',
      content: 'Ensures stable and efficient wireless connections.',
    },
    {
      id: 2,
      product: '',
      title: 'App Integration',
      content: 'Customize sound profiles and controls via dedicated apps.',
    },
    {
      id: 3,
      product: '',
      title: 'Multi-Device Pairing',
      content: 'Switch seamlessly between devices without re-pairing.',
    },
  ]
}

// Blue Headphones
let Blue_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'High-Fidelity Audio',
      content: 'Seek headphones with Hi-Res certification for superior sound reproduction.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Cancellation',
      content: 'Active noise cancelling features ensure an immersive listening experience.',
    },
    {
      id: 3,
      product: '',
      title: 'Bass Performance',
      content: 'Enhanced bass drivers provide depth for genres like EDM and hip-hop.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Ergonomic Design',
      content: 'Adjustable headbands and cushioned ear cups for prolonged use.',
    },
    {
      id: 2,
      product: '',
      title: 'Lightweight Build',
      content: 'Reduces strain during extended listening sessions.',
    },
    {
      id: 3,
      product: '',
      title: 'Secure Fit',
      content: 'Ensures stability during activities like workouts or commuting.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Long Playtime',
      content: 'Opt for models offering 30+ hours of battery life.',
    },
    {
      id: 2,
      product: '',
      title: 'Fast Charging',
      content: 'Quick charge features provide hours of use with minimal charging time.',
    },
    {
      id: 3,
      product: '',
      title: 'Wireless Charging',
      content: 'Convenient charging without the hassle of cables.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth 5.0 or Higher',
      content: 'Ensures stable and efficient wireless connections.',
    },
    {
      id: 2,
      product: '',
      title: 'App Integration',
      content: 'Customize sound profiles and controls via dedicated apps.',
    },
    {
      id: 3,
      product: '',
      title: 'Multi-Device Pairing',
      content: 'Switch seamlessly between devices without re-pairing.',
    },
  ]
}

// Pink Headphones
let Pink_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Ergonomic Design Matters',
      content: 'Ensures long listening without discomfort.',
    },
    {
      id: 2,
      product: '',
      title: 'Adjustable Headband or Ear Tips',
      content: 'A better fit equals better sound and stability.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight Construction',
      content: 'Ideal for all-day wear without ear fatigue.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Enhanced Bass Response',
      content: 'Makes music feel rich and immersive.',
    },
    {
      id: 2,
      product: '',
      title: 'Noise Isolation or Cancellation',
      content: 'Blocks out distractions for focused listening.',
    },
    {
      id: 3,
      product: '',
      title: 'Clear Call Technology',
      content: 'Perfect for remote work or calls on the go.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth 5.3 Compatibility',
      content: 'Fast, stable, and power-efficient connections.',
    },
    {
      id: 2,
      product: '',
      title: 'Touch or Button Controls',
      content: 'Easily manage volume, calls, and music.',
    },
    {
      id: 3,
      product: '',
      title: 'Voice Assistant Integration',
      content: 'Hands-free control for smart users.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Foldable or Compact Design',
      content: 'Easy to carry wherever you go.',
    },
    {
      id: 2,
      product: '',
      title: 'Color Durability',
      content: 'Pink shade stays vibrant over time.',
    },
    {
      id: 3,
      product: '',
      title: 'Travel Case Included',
      content: 'Adds convenience and protection.',
    },
  ]
}

// White Headphones
let White_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Secure fit',
      content: 'prevents slipping during movement.',
    },
    {
      id: 2,
      product: '',
      title: 'Adjustability',
      content: 'customized headband or ear tips.',
    },
    {
      id: 3,
      product: '',
      title: 'Lightweight design',
      content: 'avoids fatigue over long wear.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Driver performance',
      content: 'deep bass and clear highs.',
    },
    {
      id: 2,
      product: '',
      title: 'ANC or isolation',
      content: 'choose based on environment.',
    },
    {
      id: 3,
      product: '',
      title: 'Codec support',
      content: 'ensure include high-quality Bluetooth codecs.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Build materials',
      content: 'aluminum or quality plastic resists wear.',
    },
    {
      id: 2,
      product: '',
      title: 'Foldability',
      content: 'easy storage and travel-friendly.',
    },
    {
      id: 3,
      product: '',
      title: 'IP rating',
      content: 'look for splash or sweat-proof builds.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Long battery life',
      content: 'avoid frequent recharging.',
    },
    {
      id: 2,
      product: '',
      title: 'Fast or wireless charging',
      content: 'convenient options.',
    },
    {
      id: 3,
      product: '',
      title: 'Stable Bluetooth',
      content: 'version 5.x for lag-free audio.',
    },
  ]
}

function get_scenario_list(typeNmae){
  let arrData = []
  if(typeNmae == 'Leisure'){
    arrData = Leisure_list
  }else if(typeNmae == 'Travel'){
    arrData = Travel_list
  }else if(typeNmae == 'Fitness'){
    arrData = Fitness_list
  }else if(typeNmae == 'Work'){
    arrData = Work_list
  }else if(typeNmae == 'superior_sound_quality'){
    arrData = superior_sound_quality_list
  }else if(typeNmae == 'noise_canceling'){
    arrData = noise_canceling_list
  }else if(typeNmae == 'long_lasting_battery'){
    arrData = long_lasting_battery_list
  }else if(typeNmae == 'comfortable_fit'){
    arrData = comfortable_fit_list
  }else if(typeNmae == 'Work_Headphones'){
    arrData = Work_Headphones_list
  }else if(typeNmae == 'Travel_Headphones'){
    arrData = Travel_Headphones_list
  }

  else if(typeNmae == 'Over_Ear_Headphones'){
    arrData = Over_Ear_Headphones_list
  }else if(typeNmae == 'Waterproof_Earbuds'){
    arrData = Waterproof_Earbuds_list
  }else if(typeNmae == 'Open_Ear_Headphones'){
    arrData = Open_Ear_Headphones_list
  }else if(typeNmae == 'Ture_Wireless_Earbuds'){
    arrData = Ture_Wireless_Earbuds_list
  }else if(typeNmae == 'Hi_Res_Audio_Headphones'){
    arrData = Hi_Res_Audio_Headphones_list
  }else if(typeNmae == 'Comfortable_Headphones'){
    arrData = Comfortable_Headphones_list
  }else if(typeNmae == 'Gaming_Headphones'){
    arrData = Gaming_Headphones_list
  }else if(typeNmae == 'Long_Battery_Life_Earbuds'){
    arrData = Long_Battery_Life_Earbuds_list
  }else if(typeNmae == 'Translate_Earbuds'){
    arrData = Translate_Earbuds_list
  }else if(typeNmae == 'Sleep_Headphones'){
    arrData = Sleep_Headphones_list
  }else if(typeNmae == 'Kids_Headphones'){
    arrData = Kids_Headphones_list
  }else if(typeNmae == 'IPX7_Waterproof_Earbuds'){
    arrData = IPX7_Waterproof_Earbuds_list
  }else if(typeNmae == 'IPX8_Waterproof_Earbuds'){
    arrData = IPX8_Waterproof_Earbuds_list
  }else if(typeNmae == 'IPX6_Earbuds'){
    arrData = IPX6_Earbuds_list
  }

  else if(typeNmae == 'Behind_the_Ear_Headphones'){
    arrData = Behind_the_Ear_Headphones_list
  }else if(typeNmae == 'Foldable_Headphones'){
    arrData = Foldable_Headphones_list
  }else if(typeNmae == 'Premium_Headphones'){
    arrData = Premium_Headphones_list
  }

  else if(typeNmae == 'Black_Headphones'){
    arrData = Black_Headphones_list
  }else if(typeNmae == 'Blue_Headphones'){
    arrData = Blue_Headphones_list
  }else if(typeNmae == 'Pink_Headphones'){
    arrData = Pink_Headphones_list
  }else if(typeNmae == 'White_Headphones'){
    arrData = White_Headphones_list
  }
  return arrData
}